/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Bidding_N_Battles__Answer_5Inputs */

const en_help_center__bidding_n_battles__answer_5 = /** @type {(inputs: Help_Center__Bidding_N_Battles__Answer_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you don't win, your entry price is not refunded (as you participated in the auction), Only for Premium accounts your unused bids will become Bidbattle Loyalty Coins (BLC) in your account and never expire. You can use them in future battles to pay for bidpackage. Many players view it as entertainment with the potential to win amazing products at huge discounts!`)
};

/**
* | output |
* | --- |
* | "If you don't win, your entry price is not refunded (as you participated in the auction), Only for Premium accounts your unused bids will become Bidbattle Loy..." |
*
* @param {Help_Center__Bidding_N_Battles__Answer_5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__bidding_n_battles__answer_5 = /** @type {((inputs?: Help_Center__Bidding_N_Battles__Answer_5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Bidding_N_Battles__Answer_5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__bidding_n_battles__answer_5(inputs)
});